<template>
  <div class="order-page" v-if="this.isShowOrderEntrance">
    <div class="content-box">
      <div class="content-body">
        <div class="page-title">订单测试工具</div>
        <div style="margin-top: 30px" class="search-box search-box-small">
          <el-form :model="searchObj"
                   label-position="left"
                   label-width="auto">
            <el-form-item label="订单号">
              <el-input v-model="searchObj.orderId"
                        clearable placeholder="请输入订单号"
              ></el-input>
            </el-form-item>
            <div style="display:inline; margin-left: 10px">
              <div class="search-btn" style="font-weight: bold" @click="searchOrder">查询</div>
            </div>
            <div class="right-items" style="display:inline; margin-right: 20px; float:right">
              <el-button type="text" style="color: #F16222" @click="toHandbook" icon="el-icon-question">操作手册</el-button>
            </div>
          </el-form>
          <el-table :data="orderList" style="margin-top: 50px">
            <el-table-column prop="statusDesc" label="   状态描述" width="130" style="align-content: center">
              <template slot-scope="scope">
                <div class="inline-block">
                  <label class="status-label"
                         :style="{'backgroundColor': getColor(scope.row.status), 'width':'100px', 'font-size': '16px'}">
                    {{ scope.row.statusDesc }}
                  </label>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="状态值" width="80">
            </el-table-column>
            <el-table-column prop="orderId" label="订单号" width="200">
              <template slot-scope="scope">
                <div>
                  <label style="color: #c36d3c; font-family: 'PT Mono',monospace">{{ scope.row.orderId }}</label>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="createdTime" label="创建时间" width="130">
              <template slot-scope="scope">
                <div>
                  <label style="color: #7F7F7F; font-family: 'PT Mono',monospace">{{
                      getDate(scope.row.createdTime)
                    }}</label>
                </div>
                <div>
                  <label style="color: #7F7F7F; font-family: 'PT Mono',monospace">{{
                      getTime(scope.row.createdTime)
                    }}</label>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="用户信息" width="150">
              <template slot-scope="scope">
                <div>
                  <label style="color: #7F7F7F; font-family: 'Roboto Mono for Powerline', serif">{{
                      scope.row.contactInfo.name
                    }}</label>
                </div>
                <div>
                  <label
                      style="color: #7F7F7F; font-family: 'Roboto Mono for Powerline', serif">{{
                      scope.row.contactInfo.phone
                    }}</label>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="driverInfo" label="司机" width="150">
              <template slot-scope="scope">
                <div>
                  <div v-if="scope.row.driverBaseInfo !== undefined">
                    <label style="color: #7F7F7F; font-family: 'Roboto Mono for Powerline', serif">{{
                        scope.row.driverBaseInfo.name
                      }}</label>
                  </div>
                  <div v-if="scope.row.driverBaseInfo !== undefined">
                    <label style="color: #7F7F7F; font-family: 'Roboto Mono for Powerline', serif">{{
                        scope.row.driverBaseInfo.phone
                      }}</label>
                  </div>
                </div>
                <div v-if="scope.row.driverBaseInfo === undefined">
                  <label>-</label>
                </div>
              </template>
            </el-table-column>
            <el-table-column fixed="right" prop="actions" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button class="operation-btn" v-for="action in scope.row.actions"
                           @click="actionClicked(action, scope.row.orderId, scope.row.status, scope.row.statusDesc)"
                >{{ action.info }}
                </el-button>
                <label v-if="scope.row.actions.length === 0">无</label>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-dialog title="确认操作"
                   top="180px"
                   :modal="false"
                   class="black-bgc"
                   :visible.sync="showConfirmAlert" width="400px" center >
          <el-descriptions :label-style="{'font-size':'16px'}"
                           style="margin-left: 20%;"
                           direction="vertical"
                           :column=2
                           :colon="false">
          <el-descriptions-item label="当前状态">
            <label class="status-label"
                   :style="{'backgroundColor': this.statusColorMap[this.chosenAction.originStatus],'margin-left':'-70px','width':'150px'}"
            >{{ this.getOriginStatusDesc() }}</label>

          </el-descriptions-item>
          <el-descriptions-item label="目标状态">
            <label class="status-label"
                   :style="{'backgroundColor': this.statusColorMap[this.chosenAction.targetStatus],'margin-left':'-6px','width':'150px'}"
            >{{ this.getTargetStatusDesc() }}</label>
          </el-descriptions-item>
          </el-descriptions>
          <div v-if="chosenAction.targetStatus === 13 || chosenAction.targetStatus === 113" style="margin-top: 30px; margin-left: 10%; margin-right: 10%">
            <div>
              <label>附加费：</label>
              <el-button type="text" style="display:inline-block; font-size: 12px;" @click="copyExampleCode()">复制示例
              </el-button>
            </div>

            <el-input style="display:inline" v-model="extra" placeholder="请输入附加费"></el-input>
          </div>
          <div v-if="chosenAction.targetStatus === 14" style="margin-top: 30px; margin-left: 10%; margin-right: 10%">
            <div>
              <el-radio-group v-model="appealType">
                <el-radio :label="3">3：账单申诉</el-radio>
                <el-radio :label="4">4：费用协商</el-radio>
              </el-radio-group>
              <el-button type="text" style="display:inline-block; font-size: 12px;" @click="copyExampleCodeForBillAppeal()">复制示例
              </el-button>
            </div>
            <el-input style="display:inline" v-model="appealItems" placeholder="请输入申诉项"></el-input>
            <el-input ref="exampleCodeForBillAppeal" v-model="exampleCodeForBillAppeal" style='opacity: 0'></el-input>
          </div>
          <div v-if="chosenAction.targetStatus === 213" style="margin-top: 30px; margin-left: 10%; margin-right: 10%">
            <div>
              <el-radio-group v-model="appealType">
                <el-radio :label="3">3：账单申诉</el-radio>
                <el-radio :label="4">4：费用协商</el-radio>
              </el-radio-group>
            </div>
          </div>
          <div v-if="chosenAction.targetStatus === 114" style="margin-top: 30px; margin-left: 10%; margin-right: 10%">
            <div>
              <el-button type="text" style="display:inline-block; font-size: 12px;" @click="copyExampleCodeForBillAppealHandle()">复制示例
              </el-button>
            </div>
            <el-input style="display:inline" v-model="appealBillPrice" placeholder="请输入申诉/协商处理费用"></el-input>
            <el-input ref="exampleCodeForBillAppealHandle" v-model="exampleCodeForBillAppealHandle" style='opacity: 0'></el-input>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="showConfirmAlert = false">取 消</el-button>
            <el-button type="primary" @click="performAction()">确 定</el-button>
          </span>
        </el-dialog>
        <el-input ref="exampleCode" v-model="exampleCode" style='opacity: 0'></el-input>
      </div>
      <div class="left-items" style="display:inline; margin-left: 40px; float:left">
      订单状态流转可参考下图：
      </div>
      <div v-if="imgIsLoading">
        <img width="70%" class="order-status-img" src="../../assets/img/order/order_status.png">
      </div>

    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {ServerInterface} from "../../axios/ServerInterface";

export default {
  name: "order",
  data() {
    return {
      searchObj: {
        orderId: null,
      },
      orderList: [],
      order: {
        orderId: 102937835,
        status: 2,
        statusDesc: "未分配",
        createdTime: "",
        hasExtraFee: false,
        contactInfo: {
          name: "",
          phone: ""
        },
        driverBaseInfo: {
          id: "",
          name: "",
          phone: ""
        },
        orderDateTime: null,
        latLon: null,
        actions: [],
      },
      chosenAction: {
        orderId: null,
        originStatus: 0,
        originStatusDesc: "分配中",
        action: "",
        info: "取消",
        targetStatus: 10,
        targetStatusDesc: "逾期取消中"
      },
      extra: null,
      appealItems: null,
      appealBillPrice: null,
      appealType: null,
      handleType: null,
      imgIsLoading: true,
      isShowOrderEntrance: true,
      showConfirmAlert: false,
      statusColorMap: {
        0: '#E8AA4D', // 分配中
        1: '#74A866', // 已接单
        2: '#4A753D', // 已完成
        4: '#AAAAAA', // 拒单取消
        5: '#AAAAAA', // 逾时取消
        6: '#ECC08D', // 待支付
        7: '#C75E36', // 运送中
        10: '#1A87B5', // 运送完成
        13: '#C36D3C', // 已发送账单
        15: '#C75E36', // 装货中
        16: '#C75E36', // 卸货中
      },
      exampleCode: '[{"amount":{"number":100,"currencyCode":"CNY"},"billType":"EXTRA_TOLL_FEE"},' +
          '{"amount":{"number":100,"currencyCode":"CNY"},"billType":"EXTRA_PARKING_FEE"},' +
          '{"amount":{"number":100,"currencyCode":"CNY"},"billType":"EXTRA_PORTERAGE_FEE"},' +
          '{"amount":{"number":100,"currencyCode":"CNY"},"billType":"EXTRA_WAITING_FEE"}]',
      exampleCodeForBillAppeal:'[{"billType":21,"expectFen":50,"name":"高速费","oriPriceFen":100},' +
          '{"billType":22,"expectFen":50,"name":"停车费","oriPriceFen":100},' +
          '{"billType":23,"expectFen":50,"name":"额外搬运费","oriPriceFen":100},' +
          '{"billType":25,"expectFen":50,"name":"逾时等候费","oriPriceFen":100}]',
      exampleCodeForBillAppealHandle:'[{"billType":21,"desc":"申诉处理费用项","imgUrl":"abcdefg","name":"高速费","priceFen":20,"subType":100},' +
          '{"billType":22,"desc":"申诉处理费用项","imgUrl":"abcdefg","name":"停车费","priceFen":20,"subType":200},' +
          '{"billType":23,"desc":"申诉处理费用项","imgUrl":"abcdefg","name":"额外搬运费","priceFen":20,"subType":300},' +
          '{"billType":25,"desc":"申诉处理费用项","imgUrl":"abcdefg","name":"逾时等候费","priceFen":20,"subType":500}]'
    }
  },
  computed: {
    isPrd() {
      return location.hostname.indexOf('open.huolala.cn') !== -1;
    },
    server() {
      let sandbox = this.isPrd ? 1 : 0; // 如果是线上则使用沙箱模式
      return new ServerInterface(sandbox);
    }
  },
  mounted() {
    this.searchObj.orderId = this.$route.query.orderId;
  },

  methods: {
    getTime(createdTime) {
      let list = createdTime.split(" ")
      return list[list.length - 1];
    },

    getDate(createdTime) {
      let list = createdTime.split(" ")
      return list[0];
    },

    getColor(status) {
      let color = this.statusColorMap[status];
      return color;
    },

    actionClicked(action, orderId, status, statusDesc) {
      this.chosenAction = action;
      // this.chosenAction.targetStatus = 13;
      this.chosenAction.orderId = orderId;
      this.chosenAction.originStatus = status;
      this.chosenAction.originStatusDesc = statusDesc;
      this.showConfirmAlert = true;
    },

    getOriginStatusDesc() {
      return this.chosenAction.originStatusDesc + " " + this.chosenAction.originStatus;
    },
    getTargetStatusDesc() {
      // 申诉特殊逻辑
      if(this.chosenAction.targetStatus > 100)
        return this.chosenAction.targetStatusDesc + " " + (this.chosenAction.targetStatus % 100);
      return this.chosenAction.targetStatusDesc + " " + this.chosenAction.targetStatus;
    },


    dismissConfirmAlert() {
      this.showConfirmAlert = false;
    },

    copyExampleCode() {
      this.$refs.exampleCode.select();
      document.execCommand('copy');
      Vue.prototype.$message.success("已复制到剪切板")
    },

    copyExampleCodeForBillAppeal() {
      this.$refs.exampleCodeForBillAppeal.select();
      document.execCommand('copy');
      Vue.prototype.$message.success("已复制到剪切板")
    },

    copyExampleCodeForBillAppealHandle() {
      this.$refs.exampleCodeForBillAppealHandle.select();
      document.execCommand('copy');
      Vue.prototype.$message.success("已复制到剪切板")
    },

    toHandbook() {
      // 跳转到新的Tab页
      const {href} = this.$router.resolve({path: "/help/handbook"});
      window.open(href, '_blank');
    },

    syncRouteParam() {
      this.$router.replace({
        path: `${this.$route.path}`,
        query: {
          orderId: this.searchObj.orderId
        }
      })
    },

    searchOrder() {
      if (this.searchObj.orderId !== undefined && this.searchObj.orderId.length > 0 && this.searchObj.orderId !== "") {
        this.syncRouteParam();
        if (this.isLoading) {
          return
        }
        // 请求接口
        this.showCommonLoading();
        this.server.post("/ajax/order/query", {
          "orderId": this.searchObj.orderId
        }).then(res => {
          this.hideCommonLoading();
          if (res.data.ret === 0 && res.data.data !== undefined) {
            this.order = res.data.data;
            this.orderList = [];
            this.orderList.push(this.order);
          }
        }).catch(ex => {
          this.hideCommonLoading();
          Vue.prototype.$message.error("操作失败，请稍候重试")
        })
      }
    },

    performAction() {
      if (this.isLoading) {
        return;
      }
      let extra = null;
      let appealItems = null;
      let appealBillPrice = null;
      let appealType = null;
      let handleType = null;
      try {
        extra = JSON.parse(this.extra);
        appealItems = JSON.parse(this.appealItems);
        appealBillPrice = JSON.parse(this.appealBillPrice);
        appealType = this.appealType;
      } catch (e) {
        Vue.prototype.$message.error("解析失败！格式需为 Json 数组");
        return;
      }
      this.dismissConfirmAlert();
      this.showCommonLoading();
      let param = {
        "orderId": this.chosenAction.orderId,
        "action": this.chosenAction.action,
        "extra": JSON.parse(this.extra),
        "appealItems": JSON.parse(this.appealItems),
        "appealBillPrice": JSON.parse(this.appealBillPrice),
        "appealType": this.appealType,
        "handleType": this.handleType
      };
      if (this.chosenAction.action === 'pickup') {
        param.latLon = this.order.latLon;
        param.orderDateTime = this.order.orderDateTime;
      }
      if(this.chosenAction.action === 'appeal_handle_reject') {
        param.handleType = "驳回";
      }
      this.server.post("/ajax/order/status", param).then(res => {
        this.extra = null;
        this.appealItems = null;
        this.appealBillPrice = null;
        this.appealType = null;
        this.handleType = null;
        this.hideCommonLoading();
        if (res.data.ret === 0) {
          this.searchOrder();
        } else {
          let msg = res.data.msg;
          if (msg === undefined || msg.length === 0) {
            msg = res.data.data;
          }
          if (msg !== undefined) {
            Vue.prototype.$message.error(msg);
          }
        }
      }).catch(ex => {
        this.hideCommonLoading();
        this.extra = null;
        this.appealItems = null;
        this.appealBillPrice = null;
        this.appealType = null;
        this.handleType = null;
      })
    }
  },
}
</script>

<style scoped>

</style>

<style lang="scss" scoped>
.operation-btn {
  margin-left: 0px;
  margin-top: 10px;
  width: 130px;
  display: block;
}
.order-status-img {
  clear: both;
  display: block;
  margin: auto;
}
.black-bgc {
  background-color: rgba(0, 0, 0, 0.5);
}
.order-page {
  min-width: 1180px;
  width: 60%;
  padding: 20px 20px 30px 20px;
  margin: 0 auto;

  .page-title {
    width: 100%;
    height: 32px;
    line-height: 32px;
    font-size: 20px;
    color: #212121;
    text-align: center;
    margin: 10px 0;
    padding: 20px 20px 0px 20px;
  }

  .content-box {
    position: relative;
    min-height: 500px;
    margin-top: 25px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  }

  .content-body {
    padding: 0 40px 0px 40px;
  }

  .description-label {
    font-size: 18px;
  }

  .status-label {
    display: inline-block;
    vertical-align: center;
    line-height: 34px;
    width: 100px;
    font-size: 14px;
    text-align: center;
    color: white;
    background-color: #ECC08D;
    border-color: #ffffff;
    border-radius: 4px
  }

  /deep/ .el-dialog__header {
    height: 25px;
    font-size: 14px;
    line-height: 25px;
    .el-dialog__headerbtn {
      top: 22px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/help/order.vue